var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_1463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.95837 5H11.0417V11.875H8.95837V5Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30554 13.544C9.5111 13.4066 9.75277 13.3333 10 13.3333C10.3315 13.3333 10.6495 13.465 10.8839 13.6995C11.1183 13.9339 11.25 14.2518 11.25 14.5833C11.25 14.8306 11.1767 15.0722 11.0393 15.2778C10.902 15.4834 10.7068 15.6436 10.4784 15.7382C10.2499 15.8328 9.99861 15.8575 9.75614 15.8093C9.51366 15.7611 9.29093 15.642 9.11612 15.4672C8.9413 15.2924 8.82225 15.0697 8.77402 14.8272C8.72579 14.5847 8.75054 14.3334 8.84515 14.105C8.93976 13.8766 9.09998 13.6813 9.30554 13.544Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.5C14.1422 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1422 2.5 10 2.5C5.8579 2.5 2.50004 5.85786 2.50004 10C2.50004 14.1421 5.8579 17.5 10 17.5ZM10 19.1667C15.0626 19.1667 19.1667 15.0626 19.1667 10C19.1667 4.93739 15.0626 0.833333 10 0.833333C4.93743 0.833333 0.833374 4.93739 0.833374 10C0.833374 15.0626 4.93743 19.1667 10 19.1667Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_1463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.490fb66e42184f52ff148fabca0a376a.svg";
export { ForwardRef as ReactComponent };